import React, { useCallback, useMemo } from 'react'
import { Excluded } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { useExclusions } from 'src/components/async/document/useDocument'
import { getServiceTemplate } from 'src/xgenerated/service'
import { ExclusionsToMarkdown } from 'src/components/ModalForms/Evidence/ViewEvidenceForm/ViewEvidenceForm.utils'
import { Markup } from 'src/components/Reusable/Text/Markup'
import { EvidenceShowTabBody } from 'src/pages/Evidence/evidence.styles'

export const EvidenceExcludedBody = ({
  evidenceId,
  exclusions,
}: {
  evidenceId: string
  exclusions?: Excluded[]
}): JSX.Element => {
  const { data, isLoading } = useExclusions(evidenceId, !exclusions)
  const getServiceName = useCallback(
    (id: string) => getServiceTemplate(id)?.name || 'Unknown Service',
    [],
  )

  const exclusionBody = useMemo(() => {
    if (exclusions) {
      return ExclusionsToMarkdown(exclusions, getServiceName)
    }
    if (isLoading) {
      return 'Loading...'
    }
    const exclusionsList = data?.getExclusions()?.getExclusionsList() || []
    return ExclusionsToMarkdown(exclusionsList, getServiceName)
  }, [data, getServiceName, isLoading, exclusions])

  return (
    <EvidenceShowTabBody>
      <Markup markdown={exclusionBody} />
    </EvidenceShowTabBody>
  )
}
